
export function getEmailValue(
    val: string,
    renderer?: (val: string) => React.ReactNode,
    maxLength = 33,
    sliceLength = 30
): React.ReactNode {
    if (renderer) return renderer(val);
    return val.length > maxLength ? `${val.slice(0, sliceLength)}...` : val;
}
